import { FeathersModel } from './feathersModel'

export class JournalEntryHistoryItem extends FeathersModel {
  static serviceName = 'features/journal-entries-history'

  content: string | null = null
  dateTime: string | null = null
  authorFullName: string | null = null
}
